import React from "react";
import { Box, Button, Heading, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const CreateWithdrawal = () => {
  const navigate = useNavigate();

  return (
    <Box p={5} maxW="700px" mx="auto">
      <VStack align="stretch" spacing={4}>
        <Heading size="md">Payouts Are Managed in Stripe Connect</Heading>
        <Text color="gray.700">
          Manual withdrawal creation through the legacy bank-link flow is no longer used.
          Stripe Connect now manages payout scheduling and bank account details.
        </Text>
        <Button colorScheme="orange" onClick={() => navigate("/bank")}>
          Open Stripe Banking Setup
        </Button>
      </VStack>
    </Box>
  );
};

export default CreateWithdrawal;
